export const SKU_PREFIX = 'RSV-';
export const SKU_AUTOCOMPLETE_MAX_RESULTS = 14;
/** Max Name search results shown in Search Warehouse autocomplete. */
export const NAME_SEARCH_MAX_RESULTS = 14;
/** Debounce for Name hybrid search API calls (ms). */
export const NAME_SEARCH_DEBOUNCE_MS = 300;

export { LABEL_TYPES, type LabelType } from '@/shared/types/label.types';

export const SHELF_RANGE = {
  NUMBERS_1_TO_10: Array.from({ length: 10 }, (_, i) => i + 1),
  LETTERS_A_TO_Z: Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)),
  POSITIONS_1_TO_6: Array.from({ length: 6 }, (_, i) => i + 1),
};

// UUID pattern: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
export const UUID_PATTERN = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;
